import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useWarehouse } from '../../contexts/WarehouseContext';
import { Header } from './Header';
import { SideMenu } from './SideMenu';
import { Dashboard } from './dashboard/Dashboard';
import { ManagerDashboard } from './dashboard/ManagerDashboard';

import { ModernPickingApp } from './modules/picking/ModernPickingApp';
import { PackingApp } from './modules/packing/PackingApp';
import { ModernPutAwayApp } from './modules/putaway/ModernPutAwayApp';
import { PlaceholderModule } from './modules/PlaceholderModule';
import { ItemAdmin } from './modules/item-admin';
import { Administration, WarehouseMaintenance, SystemSettings } from './modules/administration';
import { ReasonCodeDataTable } from './modules/administration/components/ReasonCodeDataTable';
import { DeliveryMethodDataTable } from './modules/administration/components/DeliveryMethodDataTable';
import { TAConsignorMappingDataTable } from './modules/administration/components/TAConsignorMappingDataTable';
import { POrdersReceivingList, POrderReceivingDetail, OpenReceiving } from './modules/receipt';
import { InventoryApp } from './modules/inventory';
import { WarehouseTransferApp } from './modules/warehouse-transfer';
import { InventoryCorrectionApp } from './modules/inventory-correction';
import { CountingDashboard } from './modules/inventory-counting-dashboard';
import { RackBuilderApp } from './modules/rack-builder';
import { ClaudeQueryApp } from './modules/claude-query';
import { RackBuilderLiveDashboard } from './modules/rack-builder-live';
import { RealTimeStatsDashboard } from './modules/realtime-stats';
import { LocationHeatmapApp } from './modules/location-heatmap';
import { MoveProcessesApp } from './modules/move-processes';
import { ItemLocationBalanceApp } from './modules/item-location-balance';
import { TransactionHistoryApp } from './modules/transaction-history';
import { ReservationsApp } from './modules/reservations';
import { HistoryApp } from './modules/history';
import { UserProfile } from './profile/UserProfile';
import { TestModule } from './modules/testing';
import { ReportConfigurationList } from './modules/administration/ReportConfigurationList';
import { RapportDesigner } from './modules/rapport-designer';
import { Fase4Test } from './modules/rack-builder-live';
import { NewOrders } from './modules/new-orders';
import { OrderLines } from './modules/order-lines';
import NewPickingLists from './modules/new-picking-lists/NewPickingLists';
import WorkingPickingLists from './modules/new-picking-lists/WorkingPickingLists';
import WorkingOrders from './modules/working-orders/WorkingOrders';
import { CompletedPickingLists } from './modules/history/CompletedPickingLists';
import { OrderHistory } from './modules/order-history';
import { OrderTimelineModule } from './modules/order-timeline';
import { StatisticsModule } from './modules/statistics/StatisticsModule';
import { OrderRegistration } from './modules/order-registration/OrderRegistration';
import { POrderRegistration } from './modules/porder-registration/POrderRegistration';
import { PurchaseOrderLinesList } from './modules/purchase-order-lines';
import { PurchaseOrderHistoryList } from './modules/purchase-order-history';
import { BinPlacementGrunnlagApp } from './modules/bin-placement-grunnlag';
import { WarehouseApp } from './modules/administration/WarehouseApp';
import { PackZoneApp } from './modules/administration/PackZoneApp';
import { SystemRuleMaintenance } from './modules/system-rules';
import { SystemRuleGroupMaintenance } from './modules/system-rule-groups';
import { RuleComposition } from './modules/rule-composition';
import { SqlSyntaxAdmin } from './modules/sql-syntax-admin';
import { WarehouseLayoutEditor } from './modules/warehouse-layout';
import { WMSDashboard } from './modules/wms-dashboard';
import { SimulatorMain } from './modules/simulator/SimulatorMain';
import LogViewer from './modules/application-logs/LogViewer';
import { ProfileAdmin } from './modules/profile-admin';
import { FieldRegistrationApp } from './modules/field-registration';
import { CapacityRegistrationApp } from './modules/capacity-registration';
import { PrintHistory } from './modules/administration/PrintHistory';
import { DirectCustomerOrderApp } from './modules/direct-customer-order';
import { BestillingssystemMain } from './modules/bestillingssystem';
import { BestillingssystemAdminMain } from './modules/bestillingssystem-admin';
import { CountingListCreation } from './modules/counting-list-creation';
import { DataInspector } from './modules/admin-data-inspector/DataInspector';
import { DocumentDeliveryHistory } from './modules/administration/DocumentDeliveryHistory';
import { EsentralSettings } from './modules/administration/EsentralSettings';
import { FilterGroupApp } from './modules/administration/FilterGroupApp';
import { ItemTypeChange, PlaceholderEditor } from './modules/item-type-change';
//import { BarChart3, Truck, ClipboardList, Edit, Move, FileText, History, Settings, User, Shield } from 'lucide-react';
import { BarChart3, Truck, ClipboardList, Edit, Move, FileText, History, Settings, User, Shield, Warehouse } from 'lucide-react';

// Definer module config type
type ModuleId = 'dashboard' | 'manager-dashboard' | 'wms-dashboard' | 'order-registration' | 'porder-registration' | 'new-orders' | 'order-lines' | 'new-picking-lists' | 'working-picking-lists' | 'working-orders' | 'purchase-order-lines' | 'purchase-order-history' | 'completed-picking-lists' | 'order-history' | 'order-timeline' | 'modern-picking' | 'packing' | 'put-away' | 'receipt' | 'receipt-detail' | 'shipment-detail' | 'bilmottak-detail' | 'open-receiving' | 'inventory' | 'inventory-counting-dashboard' | 'inventory-counting-dashboard-balance-comparison' | 'correction' | 'movement' | 'rack-builder' | 'rack-builder-live' | 'realtime-stats' | 'location-heatmap' | 'move-processes' | 'warehouse-layout-3d' | 'claude-query' | 'item-location-balance' | 'transaction-history' | 'reservations' | 'bin-placement-grunnlag' | 'warehouse-maintenance' | 'warehouse-management' | 'system-rules' | 'system-rule-groups' | 'rule-composition' | 'sql-syntax-admin' | 'profile-admin' | 'system-settings' | 'reason-codes' | 'item-admin' | 'item-type-change' | 'placeholder-editor' | 'history' | 'reports' | 'report-configuration' | 'rapport-designer' | 'statistics' | 'administration' | 'settings' | 'profile' | 'test' | 'fase4-test' | 'simulator' | 'logs' | 'field-registration' | 'capacity-registration' | 'print-history' | 'direct-customer-order' | 'counting-list-creation' | 'admin-data-inspector' | 'document-delivery' | 'delivery-methods' | 'ta-consignor-mappings' | 'pack-zones' | 'filter-groups' | 'bestillingssystem' | 'bestillingssystem-admin';

interface ModuleConfig {
    title: string;
    component: () => React.ReactElement;
}

export const WarehouseMain: React.FC = () => {
    const { user } = useAuth();
    const { currentWarehouse } = useWarehouse();

    // Bestem default dashboard basert på OperatorGroupId
    // GroupID 1 (Operatør): Operatør Dashboard
    // GroupID 2 (Lagersjef): Lagersjef Dashboard
    // GroupID 3 (IPB/Admin): Lagersjef Dashboard
    const getDefaultDashboard = (): ModuleId => {
        if (!user?.operatorGroupId) return 'dashboard';
        return user.operatorGroupId === '2' || user.operatorGroupId === '3'
            ? 'manager-dashboard'
            : 'dashboard';
    };

    // Sjekk URL for module-parameter (for åpning i nytt vindu)
    const getInitialModule = (): ModuleId => {
        const params = new URLSearchParams(window.location.search);
        const moduleParam = params.get('module');
        if (moduleParam && isValidModuleId(moduleParam)) {
            return moduleParam as ModuleId;
        }
        return getDefaultDashboard();
    };

    // Valider at moduleId er gyldig
    const isValidModuleId = (id: string): id is ModuleId => {
        const validIds: ModuleId[] = ['dashboard', 'manager-dashboard', 'wms-dashboard', 'order-registration', 'porder-registration', 'new-orders', 'order-lines', 'new-picking-lists', 'working-picking-lists', 'working-orders', 'purchase-order-lines', 'purchase-order-history', 'completed-picking-lists', 'order-history', 'order-timeline', 'modern-picking', 'packing', 'put-away', 'receipt', 'receipt-detail', 'shipment-detail', 'bilmottak-detail', 'open-receiving', 'inventory', 'inventory-counting-dashboard', 'inventory-counting-dashboard-balance-comparison', 'correction', 'movement', 'rack-builder', 'rack-builder-live', 'realtime-stats', 'location-heatmap', 'warehouse-layout-3d', 'claude-query', 'item-location-balance', 'transaction-history', 'reservations', 'bin-placement-grunnlag', 'warehouse-maintenance', 'warehouse-management', 'system-rules', 'system-rule-groups', 'rule-composition', 'sql-syntax-admin', 'profile-admin', 'reason-codes', 'item-admin', 'item-type-change', 'placeholder-editor', 'history', 'reports', 'report-configuration', 'rapport-designer', 'statistics', 'administration', 'settings', 'profile', 'test', 'fase4-test', 'simulator', 'logs', 'field-registration', 'capacity-registration', 'print-history', 'direct-customer-order', 'counting-list-creation', 'admin-data-inspector', 'delivery-methods', 'ta-consignor-mappings', 'filter-groups', 'bestillingssystem', 'bestillingssystem-admin'];
        return validIds.includes(id as ModuleId);
    };

    const [currentModule, setCurrentModule] = useState<ModuleId>(getInitialModule());
    const [menuOpen, setMenuOpen] = useState(false);
    const [selectedOrderNo, setSelectedOrderNo] = useState<number | null>(null);
    const [selectedStcOrderNo, setSelectedStcOrderNo] = useState<number | null>(null);
    const [selectedShipmentNo, setSelectedShipmentNo] = useState<string | null>(null);
    const [selectedBilmottakBatchId, setSelectedBilmottakBatchId] = useState<string | null>(null);
    const [selectedBilmottakName, setSelectedBilmottakName] = useState<string | null>(null);
    const [selectedBilmottakWarehouse, setSelectedBilmottakWarehouse] = useState<string | null>(null);
    const [initialPListId, setInitialPListId] = useState<number | null>(null);

    // Naviger til dashboard når warehouse endres (skip initial render)
    const isFirstWarehouseRender = useRef(true);
    useEffect(() => {
        if (isFirstWarehouseRender.current) {
            isFirstWarehouseRender.current = false;
            return;
        }
        setCurrentModule(getDefaultDashboard());
    }, [currentWarehouse]);

    // Oppdater currentModule når bruker endres (ved ny innlogging), men kun hvis ikke URL-styrt
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (!params.get('module')) {
            setCurrentModule(getDefaultDashboard());
        }
    }, [user?.operatorGroupId]);

    const handleBackToDashboard = () => {
        handleModuleChange(getDefaultDashboard());
    };

    // Navigasjon fra Direkteordre til plukk med spesifikk PListId
    const handleNavigateToPickingWithPList = (pListId: number) => {
        setInitialPListId(pListId);
        setCurrentModule('modern-picking');
    };

    const moduleConfig: Record<ModuleId, ModuleConfig> = {
        'dashboard': { title: 'Dashboard', component: () => <Dashboard onModuleChange={handleModuleChange} /> },
        'manager-dashboard': { title: 'Lagersjef Dashboard', component: () => <ManagerDashboard onModuleChange={handleModuleChange} /> },
        'wms-dashboard': { title: 'WMS Dashboard', component: () => <WMSDashboard /> },
        'order-registration': { title: 'Ordreregistrering', component: () => <OrderRegistration onBack={handleBackToDashboard} /> },
        'porder-registration': { title: 'Innkjøpsordreregistrering', component: () => <POrderRegistration onBack={handleBackToDashboard} /> },
        'new-orders': { title: 'Nye Ordre', component: () => <NewOrders onBack={handleBackToDashboard} /> },
        'order-lines': { title: 'Ordrelinjer', component: () => <OrderLines onBack={handleBackToDashboard} /> },
        'new-picking-lists': { title: 'Nye Plukklister', component: () => <NewPickingLists onBack={handleBackToDashboard} /> },
        'working-picking-lists': { title: 'Plukklister under arbeid', component: () => <WorkingPickingLists onBack={handleBackToDashboard} /> },
        'working-orders': { title: 'Administrer bestillinger', component: () => <WorkingOrders onBack={handleBackToDashboard} /> },
        'purchase-order-lines': { title: 'Bestillingslinje', component: () => <PurchaseOrderLinesList onBack={handleBackToDashboard} /> },
        'purchase-order-history': { title: 'Bestillingshistorikk', component: () => <PurchaseOrderHistoryList onBack={handleBackToDashboard} /> },
        'completed-picking-lists': { title: 'Avsluttede plukklister', component: () => <CompletedPickingLists onBack={handleBackToDashboard} /> },
        'order-history': { title: 'Ordrehistorikk', component: () => <OrderHistory onBack={handleBackToDashboard} /> },
        'order-timeline': { title: 'Ordretidslinje', component: () => <OrderTimelineModule onBack={handleBackToDashboard} /> },
        'modern-picking': { title: 'Plukk', component: () => <ModernPickingApp onBack={handleBackToDashboard} initialPListId={initialPListId ?? undefined} /> },
        'packing': { title: 'Pakking', component: () => <PackingApp onBack={handleBackToDashboard} /> },
        'put-away': { title: 'Plassering', component: () => <ModernPutAwayApp initialStcOrderNo={selectedStcOrderNo || undefined} onBack={handleBackToDashboard} /> },
        'receipt': { title: 'Varemottak', component: () => <POrdersReceivingList onOrderSelect={handleOrderSelect} onBack={handleBackToDashboard} onStartOpenReceiving={handleStartOpenReceiving} onShipmentSelect={handleShipmentSelect} onBilmottakSelect={handleBilmottakSelect} /> },
        'receipt-detail': { title: 'Varemottak - Detalj', component: () => <POrderReceivingDetail orderNo={selectedOrderNo!} receivingMode="order" onBack={handleBackToList} onNavigateToPutAway={(stcOrderNo) => { setSelectedStcOrderNo(stcOrderNo); setCurrentModule('put-away'); }} /> },
        'shipment-detail': { title: 'Forsendelsesmottak', component: () => <POrderReceivingDetail inboundShipmentNo={selectedShipmentNo!} receivingMode="shipment" onBack={handleBackFromShipment} onNavigateToPutAway={(stcOrderNo) => { setSelectedStcOrderNo(stcOrderNo); setCurrentModule('put-away'); }} /> },
        'bilmottak-detail': { title: 'Bilmottak', component: () => <POrderReceivingDetail bilmottakBatchId={selectedBilmottakBatchId!} receivingMode="bilmottak" onBack={handleBackFromBilmottak} onNavigateToPutAway={(stcOrderNo) => { setSelectedStcOrderNo(stcOrderNo); setCurrentModule('put-away'); }} /> },
        'open-receiving': { title: 'Åpent mottak', component: () => <OpenReceiving onBack={handleBackToList} onNavigateToPutAway={(stcOrderNo) => { setSelectedStcOrderNo(stcOrderNo); setCurrentModule('put-away'); }} /> },
        'inventory': { title: 'Lagertelling', component: () => <InventoryApp onBack={handleBackToDashboard} /> },
        'inventory-counting-dashboard': { title: 'Telledashboard', component: () => <CountingDashboard onBack={handleBackToDashboard} /> },
        'inventory-counting-dashboard-balance-comparison': { title: 'ERP-Saldo Sammenligning', component: () => <CountingDashboard onBack={handleBackToDashboard} initialTab="balance-comparison" /> },
        'counting-list-creation': { title: 'Opprett tellelister', component: () => <CountingListCreation onBack={handleBackToDashboard} /> },
        'admin-data-inspector': { title: 'Data-inspeksjon', component: () => <DataInspector onBack={handleBackToDashboard} /> },
        'correction': { title: 'Korreksjon', component: () => <InventoryCorrectionApp onBack={handleBackToDashboard} /> },
        'movement': { title: 'Lager-/Lokasjonsflytt', component: () => <WarehouseTransferApp onBack={handleBackToDashboard} /> },
        'rack-builder': { title: 'Reolbygger', component: () => <RackBuilderApp onBack={handleBackToDashboard} /> },
        'rack-builder-live': { title: 'Live Aktivitet', component: () => <RackBuilderLiveDashboard onBack={handleBackToDashboard} /> },
        'realtime-stats': { title: 'Sanntidsstatistikk', component: () => <RealTimeStatsDashboard onBack={handleBackToDashboard} /> },
        'location-heatmap': { title: 'Lokasjon HeatMap', component: () => <LocationHeatmapApp onBack={handleBackToDashboard} /> },
        'move-processes': { title: 'Flytteplaner', component: () => <MoveProcessesApp onBack={handleBackToDashboard} /> },
        'warehouse-layout-3d': { title: '3D Lagervisning', component: () => <WarehouseLayoutEditor onBack={handleBackToDashboard} /> },
        'claude-query': { title: 'Spør Compass', component: () => <ClaudeQueryApp onBack={handleBackToDashboard} /> },
        'item-location-balance': { title: 'Vare og lokasjonssaldo', component: () => <ItemLocationBalanceApp onBack={handleBackToDashboard} /> },
        'transaction-history': { title: 'Transaksjonshistorikk', component: () => <TransactionHistoryApp onBack={handleBackToDashboard} /> },
        'reservations': { title: 'Reservasjoner', component: () => <ReservationsApp onBack={handleBackToDashboard} /> },
        'bin-placement-grunnlag': { title: 'Grunnlag - Vareplassering', component: () => <BinPlacementGrunnlagApp onBack={handleBackToDashboard} /> },
        'warehouse-maintenance': { title: 'Vedlikehold Lager', component: () => <WarehouseMaintenance onBack={handleBackToDashboard} /> },
        'warehouse-management': { title: 'Lagersted', component: () => <WarehouseApp onBack={handleBackToDashboard} /> },
        'system-rules': { title: 'Regler', component: () => <SystemRuleMaintenance onBack={handleBackToDashboard} /> },
        'system-rule-groups': { title: 'Regelgrupper', component: () => <SystemRuleGroupMaintenance onBack={handleBackToDashboard} /> },
        'rule-composition': { title: 'Regelsammensetning', component: () => <RuleComposition onBack={handleBackToDashboard} /> },
        'sql-syntax-admin': { title: 'SQL Syntaks', component: () => <SqlSyntaxAdmin onBack={handleBackToDashboard} /> },
        'item-admin': { title: 'Vareadministrasjon', component: () => <ItemAdmin onBack={handleBackToDashboard} /> },
        'item-type-change': { title: 'Bytt varetype', component: () => <ItemTypeChange onBack={handleBackToDashboard} /> },
        'placeholder-editor': { title: 'Rediger serie-/batchnummer', component: () => {
            const params = new URLSearchParams(window.location.search);
            const itemNo = params.get('itemNo');
            return <PlaceholderEditor onBack={handleBackToDashboard} initialItemNo={itemNo} />;
        } },
        'history': { title: 'Historikk', component: () => <HistoryApp onBack={handleBackToDashboard} /> },
        'reports': { title: 'Rapporter', component: () => <PlaceholderModule icon={BarChart3} title="Rapporter" /> },
        'report-configuration': { title: 'Rapportkonfigurasjon', component: () => <ReportConfigurationList onBack={handleBackToDashboard} /> },
        'rapport-designer': { title: 'Rapport-designer', component: () => <RapportDesigner onBack={handleBackToDashboard} /> },
        'statistics': { title: 'Statistikk', component: () => <StatisticsModule onBack={handleBackToDashboard} /> },
        'administration': { title: 'Administrasjon', component: () => <Administration onBack={handleBackToDashboard} onModuleChange={handleModuleChange} /> },
        'document-delivery': { title: 'Dokumentlevering', component: () => <div className="space-y-6"><EsentralSettings /><DocumentDeliveryHistory /></div> },
        'test': { title: 'Test og Debugging', component: () => <TestModule /> },
        'fase4-test': { title: 'Fase 4: Live Animasjoner', component: () => <Fase4Test /> },
        'simulator': { title: 'Warehouse Simulator', component: () => <SimulatorMain /> },
        'logs': { title: 'System Logger', component: () => <LogViewer /> },
        'profile-admin': { title: 'Profiladministrasjon', component: () => <ProfileAdmin /> },
        'system-settings': { title: 'Systeminnstillinger', component: () => <SystemSettings /> },
        'reason-codes': { title: 'Årsakskoder', component: () => <ReasonCodeDataTable /> },
        'delivery-methods': { title: 'Leveringsmåter', component: () => <DeliveryMethodDataTable /> },
        'ta-consignor-mappings': { title: 'Avsendermapping', component: () => <TAConsignorMappingDataTable /> },
        'pack-zones': { title: 'Pakkesoner', component: () => <PackZoneApp onBack={handleBackToDashboard} /> },
        'filter-groups': { title: 'Filtergrupper', component: () => <FilterGroupApp onBack={handleBackToDashboard} /> },
        'settings': { title: 'Innstillinger', component: () => <PlaceholderModule icon={Settings} title="Innstillinger" /> },
        'profile': { title: 'Brukerprofil', component: () => <UserProfile /> },
        'field-registration': { title: 'Lokasjonsvedlikehold', component: () => <FieldRegistrationApp onBack={handleBackToDashboard} /> },
        'capacity-registration': { title: 'Kapasitetsregistrering', component: () => <CapacityRegistrationApp onBack={handleBackToDashboard} /> },
        'direct-customer-order': { title: 'Direkteordre', component: () => <DirectCustomerOrderApp onNavigateToPicking={handleNavigateToPickingWithPList} onNavigateBack={handleBackToDashboard} /> },
        'bestillingssystem': { title: 'Bestillingssystem', component: () => <BestillingssystemMain onBack={handleBackToDashboard} /> },
        'bestillingssystem-admin': { title: 'Bestillingssystem – Administrasjon', component: () => <BestillingssystemAdminMain onBack={handleBackToDashboard} /> },
        'print-history': { title: 'Utskriftshistorikk', component: () => (
            <div className="space-y-6">
                <div className="flex items-center gap-3">
                    <button onClick={handleBackToDashboard} className="flex items-center gap-2 text-blue-600 hover:text-blue-800 text-sm font-medium">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m12 19-7-7 7-7"/><path d="M19 12H5"/></svg>
                        Tilbake til dashboard
                    </button>
                </div>
                <PrintHistory />
            </div>
        )}
    };

    const currentConfig = moduleConfig[currentModule];
    const ModuleComponent = currentConfig.component;

    // Oppdater nettleserfanens tittel når modul endres
    useEffect(() => {
        document.title = `${currentConfig.title} – Compass`;
    }, [currentConfig.title]);

    // Universal modul-navigering med støtte for Ctrl/Cmd+klikk (åpne i nytt vindu)
    const handleModuleChange = (moduleId: string, event?: React.MouseEvent) => {
        // Type guard for å sikre at moduleId er gyldig
        if (!(moduleId in moduleConfig)) return;

        // Ctrl+klikk (Windows) eller Cmd+klikk (Mac) åpner i nytt vindu
        if (event && (event.ctrlKey || event.metaKey)) {
            window.open(`/?module=${moduleId}`, '_blank');
            return;
        }

        setCurrentModule(moduleId as ModuleId);
    };

    const handleProfileClick = () => {
        setCurrentModule('profile');
        setMenuOpen(false);
    };

    const handleHomeClick = () => {
        setCurrentModule(getDefaultDashboard());
    };

    const handleOrderSelect = (orderNo: number) => {
        setSelectedOrderNo(orderNo);
        setCurrentModule('receipt-detail');
    };

    const handleBackToList = () => {
        setSelectedOrderNo(null);
        setCurrentModule('receipt');
    };

    const handleStartOpenReceiving = () => {
        setCurrentModule('open-receiving' as ModuleId);
    };

    // Handler for shipment selection (Modus 3: Inbound Shipment)
    const handleShipmentSelect = (shipmentNo: string) => {
        setSelectedShipmentNo(shipmentNo);
        setCurrentModule('shipment-detail');
    };

    // Handler for going back from shipment detail
    const handleBackFromShipment = () => {
        setSelectedShipmentNo(null);
        setCurrentModule('receipt');
    };

    // Handler for Bilmottak selection (Modus 4: Truck receiving)
    const handleBilmottakSelect = (batchId: string, name: string, warehouse: string) => {
        setSelectedBilmottakBatchId(batchId);
        setSelectedBilmottakName(name);
        setSelectedBilmottakWarehouse(warehouse);
        setCurrentModule('bilmottak-detail');
    };

    // Handler for going back from Bilmottak detail
    const handleBackFromBilmottak = () => {
        setSelectedBilmottakBatchId(null);
        setSelectedBilmottakName(null);
        setSelectedBilmottakWarehouse(null);
        setCurrentModule('receipt');
    };

    return (
        <div className="h-screen bg-gray-50 flex flex-col">
            <Header
                title={currentConfig.title}
                onMenuClick={() => setMenuOpen(true)}
                onProfileClick={handleProfileClick}
                onHomeClick={handleHomeClick}
                onNavigate={handleModuleChange}
            />

            <main className="flex-1 overflow-auto">
                <div className={`mx-auto ${
                    currentModule === 'rack-builder' ||
                    currentModule === 'rack-builder-live' ||
                    currentModule === 'realtime-stats' ||
                    currentModule === 'location-heatmap' ||
                    currentModule === 'move-processes' ||
                    currentModule === 'warehouse-layout-3d' ||
                    currentModule === 'claude-query' ||
                    currentModule === 'item-location-balance' ||
                    currentModule === 'transaction-history' ||
                    currentModule === 'reservations' ||
                    currentModule === 'fase4-test' ||
                    currentModule === 'order-registration' ||
                    currentModule === 'porder-registration' ||
                    currentModule === 'new-orders' ||
                    currentModule === 'order-lines' ||
                    currentModule === 'new-picking-lists' ||
                    currentModule === 'working-picking-lists' ||
                    currentModule === 'working-orders' ||
                    currentModule === 'purchase-order-lines' ||
                    currentModule === 'purchase-order-history' ||
                    currentModule === 'completed-picking-lists' ||
                    currentModule === 'order-history' ||
                    currentModule === 'manager-dashboard' ||
                    currentModule === 'wms-dashboard' ||
                    currentModule === 'warehouse-maintenance' ||
                    currentModule === 'warehouse-management' ||
                    currentModule === 'system-rules' ||
                    currentModule === 'system-rule-groups' ||
                    currentModule === 'rule-composition' ||
                    currentModule === 'sql-syntax-admin' ||
                    currentModule === 'inventory-counting-dashboard' ||
                    currentModule === 'report-configuration' ||
                    currentModule === 'rapport-designer' ||
                    currentModule === 'simulator' ||
                    currentModule === 'administration' ||
                    currentModule === 'bin-placement-grunnlag' ||
                    currentModule === 'reason-codes' ||
                    currentModule === 'delivery-methods' ||
                    currentModule === 'ta-consignor-mappings' ||
                    currentModule === 'admin-data-inspector' ||
                    currentModule === 'pack-zones' ||
                    currentModule === 'filter-groups'
                    ? 'max-w-none p-0 h-full' : 'max-w-7xl p-6'
                }`}>
                    <ModuleComponent />
                </div>
            </main>

            <SideMenu
                isOpen={menuOpen}
                onClose={() => setMenuOpen(false)}
                currentModule={currentModule}
                onModuleChange={handleModuleChange}
            />
        </div>
    );
};
